import { createSlice } from "@reduxjs/toolkit";

const initialState = 0;

export const reloadDocuments = createSlice({
    name: "reloadDocuments",
    initialState,
    reducers: {
        reload: (state) => state + 1,
    }
})

export const { reload } = reloadDocuments.actions

export default reloadDocuments.reducer